module.exports = __webpack_public_path__ + "static/img/bg-es.8ae19f09.png";